import React from 'react';
import { Chart as ChartJS, CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend } from 'chart.js';
import { Bar } from 'react-chartjs-2';
import { COLORS } from '../../styles/globals';

ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);

interface ChartProps {
  labels: string[];
  values: number[];
  label: string;
}

const Chart = ({ labels, values, label }: ChartProps) => {
  const data = {
    labels: labels,
    datasets: [
      {
        label: label,
        data: values,
        borderColor: COLORS.brand02,
        backgroundColor: 'rgba(81, 139, 51, 0.2)',
        borderWidth: 2,
        borderRadius: Number.MAX_VALUE,
        borderSkipped: false,
      },
    ],
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    scales: {
      y: {
        beginAtZero: true,
        ticks: {
          stepSize: 50,
          precision: 0,
          display: false,
        },
      },
      x: {
        ticks: {
          display: false,
        },
      },
    },
    plugins: {
      legend: {
        position: 'top',
      },
    },
  };

  return (
    <div style={{ height: 300 }}>
      <Bar data={data} options={options as any} />
    </div>
  );
};

export default Chart;
